//@flow
import React from 'react';
import modal from '../../Modal/components/StandardModal.react';
import LoginForm from '../../SignIn/components/LoginFormWrapper.react';
import Constants from '../../constants';

import type { ModalProps } from '../../Modal/components/StandardModal.react';

function LoginModal(props:ModalProps) {
  return (
    <LoginForm
      initialNewUser={false}
      modal={true}
      {...props}
    />
  );
}

export default modal<{}>(LoginModal, {
  name: Constants.LOGIN_MODAL,
  className: 'login-modal',
});
